import Icon from "../../a-atoms/icons/Icon";
import style from "./Label.module.css";

const Label = (props) => {
  return (
    <span
      className={`${style.label} ${
        props.variants ? props.variants.map((i) => style[i]).join(" ") : null
      } ${props.editable && style.editable} ${
        props.selected && style.selected
      }`}
      style={props.data && { backgroundColor: "var(" + props.data.color + ")" }}
    >
      {props.children}{" "}
      <span>
        {props.editable ? (
          <Icon onClick={() => props.onRemoveLabel(props.data)}>remove</Icon>
        ) : null}
      </span>
    </span>
  );
};

export default Label;
